import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MailsAccountListComponent } from './mails-account-list/mails-account-list.component';
import { MailsAccountDetailComponent } from './mails-account-detail/mails-account-detail.component';
import { MailsAccountListMailboxesComponent } from './mails-account-list-mailboxes/mails-account-list-mailboxes.component';

const routes: Routes = [
    {
       path: 'mailsAccounts',
       children: [
         { path: '', component: MailsAccountListComponent },
         { path: ':id', component: MailsAccountDetailComponent }
       ]
    },
    { path: 'mailboxes', component: MailsAccountListMailboxesComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MailsAccountsRoutingModule { }
